module.exports = __webpack_public_path__ + "medias/images/warehouse-pin.png";